import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-cycle
import Footer from "./Footer";
import amplitudeAnalytics, { AMPLITUDE_NAV_SECTION } from "../../shared/utilities/amplitude";
import useBrandRefresh from "../../shared/hooks/useBrandRefresh";
import { getStoreButtonClass } from "./footerBrandRefreshClasses";
import "./FooterSectionBrandRefresh.module.css";

const AppleStoreIcon = require("./imgs/logo-apple.svg");
const PlayStoreIcon = require("./imgs/logo-google-playstore.svg");
const BrandRefreshAppleStoreIcon = require("./imgs/brand-refresh-logo-apple.svg");
const BrandRefreshPlayStoreIcon = require("./imgs/brand-refresh-logo-google-playstore.svg");
const MobileIcon = require("./imgs/mobile.png");

export const getStoreIcons = (brandRefresh) =>
  brandRefresh
    ? {
        apple: BrandRefreshAppleStoreIcon,
        playStore: BrandRefreshPlayStoreIcon,
      }
    : {
        apple: AppleStoreIcon,
        playStore: PlayStoreIcon,
      };

function FooterSection({ pathname }) {
  const { isBrandRefresh } = useBrandRefresh();
  const storeIcons = getStoreIcons(isBrandRefresh);

  const trackAppDownload = navElement => {
    amplitudeAnalytics.trackClickNavPrimary({
      navElement,
      navSection: AMPLITUDE_NAV_SECTION.FOOTER,
      pathname:
        typeof window !== "undefined" ? window.location.pathname : undefined,
    });
  };

  const storeButtonLabelClass = isBrandRefresh ? "m-0" : "text-lg font-montserratBold tracking-tighter";

  return (
    <div
      className="w-full flex flex-col items-center justify-center gap-0"
      data-donations-footer={/\/donations\/?$/.test(pathname) ? 'true' : undefined}
    >
      <div
        data-region={isBrandRefresh ? "app-downloads" : undefined}
        className={
          isBrandRefresh
            ? "w-full bg-brandRefresh-surface-container"
            : "w-full bg-mainLight lg:h-[370px]"
        }
      >
        {isBrandRefresh ? (
          <div data-part="app-bar-inner" className="w-full">
            <div data-part="app-bar-content">
              <div data-part="app-headline-align">
                <h2
                  data-part="app-headline"
                  className="m-0"
                >
                  Easy ordering,
                  {' '}
                  <br data-part="app-headline-break" />
                  sweet rewards
                </h2>
              </div>
              <div data-part="store-buttons" className="shrink-0">
                <a
                  data-part="store-button-app-store"
                  href="https://apps.apple.com/us/app/insomnia-cookies/id891379973"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={getStoreButtonClass(true)}
                  aria-label="Download Insomnia Cookies app from the App Store (opens in new tab)"
                  onClick={() => trackAppDownload("iOS app download")}
                >
                  <img
                    className="store-button-icon"
                    src={storeIcons.apple}
                    alt=""
                    aria-hidden="true"
                  />
                  <span data-part="store-button-label" className={storeButtonLabelClass}>App Store</span>
                </a>
                <a
                  data-part="store-button-google-play"
                  href="https://play.google.com/store/apps/details?id=com.insomniacookies.insomnia"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={getStoreButtonClass(true)}
                  aria-label="Download Insomnia Cookies app from Google Play (opens in new tab)"
                  onClick={() => trackAppDownload("Google Play")}
                >
                  <img
                    className="store-button-icon"
                    src={storeIcons.playStore}
                    alt=""
                    aria-hidden="true"
                  />
                  <span data-part="store-button-label" className={storeButtonLabelClass}>Google Play</span>
                </a>
              </div>
            </div>
          </div>
        ) : (
          <div className="max-w-screen-desktop mx-auto">
            <div className="relative">
              <div className="lg:grid grid-flow-col place-items-center lg:absolute top-[-30px] left-0">
                <div>
                  <img src={MobileIcon} alt="" />
                </div>
                <div className="py-[10%] lg:py-0 px-4" data-part="legacy-app-copy">
                  <h2 className="font-congenialBlack text-4xl leading-9 tracking-[-1px] text-white  pr-16">
                    Easy ordering, sweet rewards
                  </h2>
                  <p className="text-lg leading-[22px] tracking-[-0.1px] text-white font-montserratMedium">
                    Save time when you order with our app. Join Insomnia Rewards and
                    earn free treats.
                  </p>
                  <div className="mt-4 flex gap-3" data-part="legacy-app-buttons">
                    <a
                      href="https://apps.apple.com/us/app/insomnia-cookies/id891379973"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="h-[54px] w-[157px] 
                  rounded-[54px] py-3 bg-transparent border border-solid border-white
                   text-white font-montserratBold"
                      aria-label="Download Insomnia Cookies app from the App Store (opens in new tab)"
                      onClick={() => trackAppDownload("iOS app download")}
                    >
                      <div className="flex gap-2 text-center items-center justify-center h-[22px] mt-1" aria-hidden="true">
                        <img
                          className="w-5 h-5"
                          src={storeIcons.apple}
                          alt=""
                          aria-hidden="true"
                        />
                        <p className="text-lg font-montserratBold tracking-tighter">
                          App Store
                        </p>
                      </div>
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.insomniacookies.insomnia"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="h-[54px] w-[175px] 
                   rounded-[54px] 
                   py-3 bg-transparent border border-solid border-white
                   text-white font-montserratBold"
                      aria-label="Download Insomnia Cookies app from Google Play (opens in new tab)"
                      onClick={() => trackAppDownload("Google Play")}
                    >
                      <div className="flex gap-2 text-center items-center justify-center h-[22px] mt-1" aria-hidden="true">
                        <img
                          src={storeIcons.playStore}
                          alt=""
                          aria-hidden="true"
                        />
                        <p className="text-lg font-montserratBold tracking-tighter">
                          Google Play
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

FooterSection.propTypes = { pathname: PropTypes.string };
FooterSection.defaultProps = { pathname: '' };
export default FooterSection;
